// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LYQE","controls":"styles_controls__38bpw","charLimit":"styles_charLimit__3zYni","input":"styles_input__1YO64","send":"styles_send__2XdN2"};